import React, { useState } from "react";
import { Alert, Box, Button, Container, Grid, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { Bio } from "../../data/constants";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [feedback, setFeedback] = useState({ state: false, msg: "", sev: "success" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setFeedback({ state: true, msg: "Missing required fields.", sev: "error" });
      return;
    }
    fetch("/api/contact", {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form)
    })
      .then((r) => r.ok ? setFeedback({ state: true, msg: "TRANSMISSION SUCCESS", sev: "success" }) : Promise.reject())
      .catch(() => setFeedback({ state: true, msg: "TRANSMISSION FAILED. RETRY.", sev: "error" }))
      .finally(() => setForm({ name: "", email: "", subject: "", message: "" }));
  };

  return (
    <Box id="contact" sx={{ py: { xs: 8, md: 14 } }}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="flex-end" spacing={4} sx={{ mb: 10 }}>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif", fontWeight: 300,
            fontSize: { xs: "2.5rem", md: "4.5rem" }, color: "#e6e8ec",
            lineHeight: 1, letterSpacing: "-0.02em",
          }}>
            COMM_LINK
          </Typography>
          <Box sx={{ flex: 1, height: 1, bgcolor: "rgba(107, 117, 130, 0.3)", mb: 2 }} />
          <Typography sx={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: "0.85rem",
            color: "#6b7582", letterSpacing: "0.1em", mb: 2, display: { xs: "none", sm: "block" }
          }}>
            SECURE CHANNEL
          </Typography>
        </Stack>

        <Grid container spacing={8}>
          <Grid item xs={12} md={5}>
            <Stack spacing={4}>
              <Box>
                <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#6b7582", letterSpacing: "0.15em", mb: 1 }}>
                  DIRECT_INBOX
                </Typography>
                <Typography component="a" href={`mailto:${Bio.email}`} sx={{
                  fontFamily: "'JetBrains Mono', monospace", fontSize: "1.2rem",
                  color: "#00f0ff", textDecoration: "none", "&:hover": { textShadow: "0 0 10px rgba(0,240,255,0.4)" }
                }}>
                  {Bio.email}
                </Typography>
              </Box>
              
              <Box>
                <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#6b7582", letterSpacing: "0.15em", mb: 2 }}>
                  EXTERNAL_NODES
                </Typography>
                <Stack direction="row" spacing={3}>
                  <Box component="a" href={Bio.linkedin} target="_blank" sx={{ color: "#e6e8ec", textDecoration: "none", fontFamily: "'Inter', sans-serif", fontSize: "1.1rem", "&:hover": { color: "#00f0ff" } }}>
                    LinkedIn
                  </Box>
                  <Box component="a" href={Bio.github} target="_blank" sx={{ color: "#e6e8ec", textDecoration: "none", fontFamily: "'Inter', sans-serif", fontSize: "1.1rem", "&:hover": { color: "#00f0ff" } }}>
                    GitHub
                  </Box>
                  <Box component="a" href={Bio.twitter} target="_blank" sx={{ color: "#e6e8ec", textDecoration: "none", fontFamily: "'Inter', sans-serif", fontSize: "1.1rem", "&:hover": { color: "#00f0ff" } }}>
                    Twitter
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Box component="form" onSubmit={handleSubmit} className="tactical-border cyber-clip" sx={{ p: { xs: 3, md: 5 }, bgcolor: "rgba(5, 8, 18, 0.85)" }}>
              <Stack spacing={3}>
                <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.8rem", color: "#00f0ff", letterSpacing: "0.1em", mb: 2 }}>
                  {">"} INITIATE_TRANSFER
                </Typography>
                
                <TextField label="OPERATIVE_NAME *" name="name" value={form.name} onChange={handleChange} variant="standard" 
                  InputProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#e6e8ec", fontSize: "0.9rem", py: 1 } }}
                  InputLabelProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#6b7582", fontSize: "0.8rem" } }} />
                  
                <TextField label="REPLY_ADDRESS *" name="email" value={form.email} onChange={handleChange} variant="standard"
                  InputProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#e6e8ec", fontSize: "0.9rem", py: 1 } }}
                  InputLabelProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#6b7582", fontSize: "0.8rem" } }} />

                <TextField label="SUBJECT_HEADER" name="subject" value={form.subject} onChange={handleChange} variant="standard"
                  InputProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#e6e8ec", fontSize: "0.9rem", py: 1 } }}
                  InputLabelProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#6b7582", fontSize: "0.8rem" } }} />

                <TextField label="ENCRYPTED_PAYLOAD *" name="message" value={form.message} onChange={handleChange} variant="standard" multiline minRows={4}
                  InputProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#e6e8ec", fontSize: "0.9rem", py: 1 } }}
                  InputLabelProps={{ sx: { fontFamily: "'JetBrains Mono', monospace", color: "#6b7582", fontSize: "0.8rem" } }} />

                <Button type="submit" variant="outlined" sx={{ mt: 2, alignSelf: "flex-start" }}>
                  TRANSMIT_DATA
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Snackbar open={feedback.state} autoHideDuration={4000} onClose={() => setFeedback({ ...feedback, state: false })}>
        <Alert severity={feedback.sev} sx={{ bgcolor: "rgba(2,4,10,0.9)", border: `1px solid ${feedback.sev === "error" ? "red" : "#00f0ff"}`, color: feedback.sev === "error" ? "red" : "#00f0ff", borderRadius: 0 }}>
          {feedback.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Contact;
